<template>
    <div>
      <div v-if="showPredictiveResults" class="overlay" @click="closeOverlay"></div>
      <div class="search-box">
        <input v-model="searchQuery" @input="fetchPredictiveResults" placeholder="Buscar invitados...">
        <ul v-if="showPredictiveResults && predictiveResults.length > 0">
          <li v-for="staff in predictiveResults" :key="staff.staff_id || staff.correo || staff.numero_de_documento" @click="selectStaff(staff)">
            {{ staff.nombre }} - {{ staff.correo || 'sin correo' }} - Doc: {{ staff.numero_de_documento || 'sin documento' }} - {{ staff.escarapela }} - {{ staff.evento }}
          </li>
        </ul>
        <div v-if="showPredictiveResults && predictiveResults.length === 0" class="no-results">
          No hay coincidencias
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';

  export default {
    name: 'SearchStaff',
    computed: {
      ...mapState(['user']),
    },
    data() {
      return {
        searchQuery: '',
        predictiveResults: [],
        showPredictiveResults: false,
      };
    },
    methods: {
      fetchPredictiveResults() {
        clearTimeout(this.searchTimeout);

        if (this.searchQuery.length > 0) {
          this.searchTimeout = setTimeout(() => {
            fetch('/api/search-staff', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                query: this.searchQuery,
                user_token: this.user?.token 
              })
            })
            .then(response => response.json())
            .then(data => {
              this.predictiveResults = data.data;
              this.showPredictiveResults = true;
            })
            .catch(error => console.error('Error fetching data:', error));
          }, 300);
        } else {
          this.showPredictiveResults = false;
        }
      },

      selectStaff(staff) {
        const lookup = staff.staff_id
          ? `staff-${staff.staff_id}`
          : (staff.correo || staff.numero_de_documento || '').trim();

        if (!lookup) return;

        const url = `/lista-usuarios/${staff.event_token}/${encodeURIComponent(lookup)}`;
        this.$router.push(url);
        this.closeOverlay();
      },
      closeOverlay() {
        this.searchQuery = '';
        this.showPredictiveResults = false;
      }
    },
  };
  </script>

<style scoped lang="sass">
input
  width: 100%
  max-width: 400px
  padding: 10px 15px
  margin: 15px 0 5px 0
  border: none
  box-shadow: 5px 5px 5px rgba(0,0,0,0.3)
  transition: all 0.2s
  &:hover
    box-shadow: 5px 5px 10px rgba(0,0,0,0.6)    
  
.overlay 
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  background-color: rgba(0, 0, 0, 0.5)
  z-index: 9
  transition: opacity 0.2s ease-in-out
  opacity: 1

.overlay-hide 
  opacity: 0
  pointer-events: none

.search-box 
  position: relative
  width: 100%
  max-width: 400px
  margin: -20px auto 0 auto
  z-index: 10

.search-box ul 
  position: absolute
  width: 100%
  list-style-type: none
  padding: 0
  box-shadow: 0 0 10px rgba(155, 155, 155, 0.5)
  border-radius: 5px
  overflow: hidden
  z-index: 10

.search-box li 
  cursor: pointer
  background: #fff
  padding: 10px 20px
  border-bottom: 1px solid #ccc
  font-weight: bold
  // font-size: 0.7em
  text-align: left
  transition: all 0.2s
  &:hover
    background: #e5e5e5

  span
    display: block
    font-weight: lighter
    font-size: 0.8em

.no-results
  padding: 30px
  width: 100%
  text-align: center
  background: #fff
  position: absolute
  box-shadow: 0 0 10px rgba(155, 155, 155, 0.5)
  border-radius: 5px
  overflow: hidden
  z-index: 10
</style>
  